import _ from 'lodash'

export default loginCtrl

/** @ngInject */
function loginCtrl($scope, $q, $uibModal, $state, $stateParams, $window, User, ApiService, AlertManager, PotManager, ContractService,
ContractDraft, gaEventsService, ErrorCatcher) {
    $scope.gaEventsService = gaEventsService
    $scope.user = {}
    $scope.fromCommunity = $stateParams.source === 'communaute'
    $scope.source = $stateParams.source
    $scope.redirectTo = $stateParams.redirectTo
    ApiService.resetPromise('userInfo')
    $scope.dataFeature = false
    $scope.loginError = false
    $scope.sendResetPasswd = false
    $scope.sendResetPasswdSuccess = false
    $scope.incorrectEmail = false
    $scope.unknownError = false
    $scope.isLogin = false

    $scope.openSubscriptionModal = () => {
        gaEventsService.newEvent('click - Je souscris')
        $uibModal.open({
            animation: true,
            component: 'subscriptionModal',
            resolve: {
                stateParams: () => ({
                    source: $stateParams.source,
                    redirectTo: $stateParams.redirectTo,
                }),
            },
        })
    }

    $scope.sendResetPassword = (user) => {
        User.resetPassword({ email: user.username }).$promise.then(() => {
            $scope.sendResetPasswdSuccess = true
        }).catch((error) => {
            if (error.status === 400) {
                $scope.incorrectEmail = true
            } else {
                $scope.unknownError = true
            }
            ErrorCatcher.catchErrorWithoutRedirect(error)
        }).finally(() => {
            $scope.loginError = false
            $scope.sendResetPasswd = true
        })
    }

    $scope.login = function (user) {
        $scope.isLogin = true
        $scope.loginError = false
        const authenticate$ = User.authenticate(user).$promise
        authenticate$.catch((error) => {
            const message = error.data ? error.data.message : 'Erreur inconnue'
            $scope.loginError = true
            $scope.isLogin = false
            ErrorCatcher.catchErrorWithoutRedirect(error)
        })
        return authenticate$.then(() => {
            gaEventsService.newEvent('click - Login - success')

            // Clear data
            AlertManager.clearAlerts()
            ApiService.resetPromise('userInfo')
            ApiService.resetPromise('features')
            PotManager.resetPot()
            localStorage.removeItem('hideDashboard')
            localStorage.removeItem('subscriptionToken')

            const userInfo = ApiService.fetchUserInfo()
            .catch((error) => {
                ErrorCatcher.catchError(error)
                return {}
            })
            const contractDraft = ContractDraft.get({ create: false, silent: true }).$promise
            .catch((error) => {
                ErrorCatcher.catchError(error)
                return {}
            })
            return $q.all({ userInfo, contractDraft })
        })
        .then((values) => {
            // Redirect rules
            if ($scope.redirectTo && $scope.redirectTo.startsWith('/')) {
                $window.location.href = $scope.redirectTo
                return
            } else if ($scope.redirectTo === 'endSubscription') {
                return $state.go($scope.redirectTo, $stateParams)
            } else if (values.contractDraft.ready_to_checkout) {
                return $state.go('subscriptionSummary')
            } else if (!_.isEmpty(ContractService.findFirstGoalNotDefinedContract(values.userInfo.contracts))) {
                return $state.go('endSubscription')
            } else if ($scope.fromCommunity) {
                if (($scope.redirectTo !== undefined) && ($scope.redirectTo !== 'undefined')) {
                    $window.location.href = `/communaute${$scope.redirectTo}`
                    return
                }
                return $state.go('community')
            } else if ($scope.redirectTo !== undefined) {
                return $state.go($scope.redirectTo, $stateParams)
            }
            const unpaidContract = ContractService.findFirstUnpaidContract(values.userInfo.contracts)
            if (!_.isEmpty(unpaidContract)) {
                return $state.go('invoice', { contractId: unpaidContract.id })
            }
            const selectedContract = ContractService.findFirstNotFinishedContract(values.userInfo.contracts)
            if (!_.isEmpty(selectedContract)) {
                return $state.go('account', { contractId: selectedContract.id })
            }
            if (_.isEmpty(values.userInfo.contracts)) {
                return $state.go('subscription', { bulk_purchase: $stateParams.bulk_purchase })
            }
            return $state.go('account')
        })
        .catch((error) => {
            if (!error.message === 'transition prevented') {
                ErrorCatcher.catchErrorWithoutRedirect(error)
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/states/login/login.js